import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import i18next from "i18next";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import { SelectChangeEvent } from "@mui/material";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import NavigationRoutes from "@common/enums/query-params/sphere-navigation-routes";
import SelectInput from "components/forms/SelectInput";
import { availableApiLanguages, getCurrentLanguage, STORED_LANG_KEY } from "../../i18n";
import PublicLayoutContext from "./PublicLayoutContext";
import PublicNavigationBar from "./PublicNavigationBar";
import SideNavLayout from "components/ui/SideNavLayout";

const PublicLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [language, setLanguage] = useState<string>(getCurrentLanguage().languageCode);

  const languageChangeHandler = (event: SelectChangeEvent<unknown>) => {
    const selectedLanguage = event.target.value as string;
    setLanguage(selectedLanguage);
    i18next.changeLanguage(selectedLanguage, (err) => {
      if (err) {
        return console.log("language could not be changed", err);
      }
      localStorage.setItem(STORED_LANG_KEY, selectedLanguage);
    });
  };

  const loginClickHandler = () => {
    navigate(NavigationRoutes.Dashboard);
  };

  return (
    <PublicLayoutContext.Provider value={{ isInPublicLayout: true, language }}>
      <SideNavLayout
        dataTestId="public-layout"
        actions={
          <React.Fragment>
            <SelectInput
              value={language}
              fullWidth={false}
              onChange={languageChangeHandler}
              data-testid="select-language"
            >
              {availableApiLanguages.map((availableLanguage) => (
                <MenuItem key={availableLanguage.languageCode} value={availableLanguage.languageCode}>
                  {t("language-" + availableLanguage.languageCode)}
                </MenuItem>
              ))}
            </SelectInput>

            <Button
              variant="contained"
              startIcon={<LoginRoundedIcon />}
              onClick={loginClickHandler}
              data-testid="public-login-button"
            >
              {t("button-login")}
            </Button>
          </React.Fragment>
        }
        renderNavigationBar={(isNavOpen, onNavChangeHandler) => (
          <PublicNavigationBar isNavOpen={isNavOpen} onNavChangeHandler={onNavChangeHandler} />
        )}
      >
        {children}
      </SideNavLayout>
    </PublicLayoutContext.Provider>
  );
};

export default PublicLayout;
